import {IdentityAsJson, IdentityProvider, IdentityProviderOptions} from "orbit-db-identity-provider"
import forge from "node-forge"
import {Ed25519Keypair} from "../interfaces/keys"

const ed25519 = forge.pki.ed25519

// Check out https://github.com/orbitdb/orbit-db-identity-provider for details
export class Ed25519IdentityProvider extends IdentityProvider {
  static get type() {
    return "Ed25519IdentityProvider"
  }

  async getId(options?: IdentityProviderOptions): Promise<string> {
    const keypair: Ed25519Keypair | null = options?.keypair
    if (keypair == null) {
      return ""
    }
    return keypair.publicKey.toString("hex")
  }

  async signIdentity(data: any, options?: { [key: string]: any, id: string }): Promise<any> {
    const keypair: Ed25519Keypair | null = options?.keypair
    if (keypair == null) {
      return
    }
    const signature = ed25519.sign({
      message: data,
      encoding: "utf8",
      privateKey: keypair.privateKey
    })
    return signature.toString("hex")
  }

  static async verifyIdentity(identity: IdentityAsJson): Promise<boolean> {
    return ed25519.verify({
      message: identity.publicKey + identity.signatures.id,
      encoding: "utf8",
      signature: forge.util.hexToBytes(identity.signatures.publicKey),
      publicKey: forge.util.hexToBytes(identity.id)
    })
  }
}
